import logo from './logo.svg';
import './App.css';
import AppRoutes from './Routes/AllRoutes';

function App() {
  return (
    <div className="App">
      <AppRoutes/>
    </div>
  );
}

export default App;
